// Node packages
import React from 'react';
import Heading from '@react/react-spectrum/Heading';
import { TabView, Tab } from '@react/react-spectrum/TabView';

// Custom styling and utils
import ViewAvailableOffersPage from './components/ViewAvailableOffersPage/ViewAvailableOffersPage';
import ViewAvailableCountriesPage from './components/ViewAvailableCountriesPage/ViewAvailableCountriesPage';
import ViewFileLinksPage from './components/ViewFileLinksPage/ViewFileLinksPage';
import ViewErrorCodesPage from "./components/ViewErrorCodesPage/ViewErrorCodesPage";
import ViewLanguageCodesPage from './components/ViewLanguageCodesPage/ViewLanguageCodesPage';
import {isFlexPromoFlagDevEnabled, isFlexPromoFlagEnabled} from "../config/FeatureFlags";
import ViewEditAvailableFlexDiscountsPage from "./components/FlexDiscountsPage/ViewEditAvailableFlexDiscountsPage";

/**
 * OffersPage contains the page to organize and view product offers.
 */

const ResourcesTab = ['View Available Offers', 'View Available Countries', 'Partner API Files & Links', 'View Error Codes', 'View Locales', 'View Available Flex Discounts'];

function ResourcesPage(): React.ReactElement {
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const handleTabChange = (newSelectedTabIndex: number) => {
        console.log('Selected tab: ', newSelectedTabIndex);
        setSelectedIndex(newSelectedTabIndex);
    };

    return (
        <div>
            <Heading variant="pageTitle">Portal Resources</Heading>
            <TabView selectedIndex={selectedIndex} onSelect={handleTabChange}>
                {ResourcesTab.map((tabItem, index) => {
                    if (index === 5) {
                        if (isFlexPromoFlagDevEnabled() || isFlexPromoFlagEnabled()) {
                            return <Tab key={index} label={tabItem}/>;
                        } else {
                            return null;
                        }
                    } else {
                        return <Tab key={index} label={tabItem}/>;
                    }
                })}
            </TabView>

            {selectedIndex === 0 && <ViewAvailableOffersPage/>}
            {selectedIndex === 1 && <ViewAvailableCountriesPage/>}
            {selectedIndex === 2 && <ViewFileLinksPage/>}
            {selectedIndex === 3 && <ViewErrorCodesPage/>}
            {selectedIndex === 4 && <ViewLanguageCodesPage/>}
            {selectedIndex === 5 && (isFlexPromoFlagDevEnabled() || isFlexPromoFlagEnabled()) && <ViewEditAvailableFlexDiscountsPage/>}
        </div>
    );
}
export default ResourcesPage;
